import React, { useState } from 'react';

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import ModalConfirm from '~/commons/components/ModalConfirm.jsx';

const BtnDel = ({
  api,
  onDel = () => {},
}) => {
  const [res, req] = useHttpStatus();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ModalConfirm
        show={showModal}
        onReject={() => setShowModal(false)}
        onConfirm={async () => {
          setShowModal(false);

          await req({
            method: 'delete',
            ...api,
          });

          onDel();
        }}
      >
        Are you sure you want to delete?
      </ModalConfirm>
      <FormHttpBtn
        className="btn btn-outline-primary"
        type="button"
        res={res}
        icon={faTrashAlt}
        onClick={() => setShowModal(true)}
      >
        Delete
      </FormHttpBtn>
    </>
  );
};

export default BtnDel;
